import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { SMART_ID_ERROR } from 'consts';
import { connect } from 'react-redux';
import { logout } from 'actions/authentication';
import { attachLogoutToLink } from 'utils/helpers';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  logout: PropTypes.func,
};

class AuthenticationErrorMessage extends Component {
  constructor(props) {
    super(props);
    this.getValuesFromMessage = this.getValuesFromMessage.bind(this);
    this.exception409 = React.createRef(null);
  }

  componentDidUpdate() {
    if (this.exception409.current) {
      attachLogoutToLink(this.exception409, this.props.logout);
    }
  }

  getValuesFromMessage(values) {
    const { messages } = this.props.intl;
    if (values) {
      return Object.keys(values).reduce((acc, key) => {
        const value = messages[values[key]] || values[key];
        return {
          ...acc,
          [key]: value.startsWith(SMART_ID_ERROR) ? '' : value,
        };
      }, {});
    }
    return 'aio.errorCode.default';
  }

  render() {
    const { authentication } = this.props;
    let errorBody;

    if (!authentication.exception && !authentication.errorMessage && !authentication.errorCode) {
      return null;
    }

    if (authentication.exception) {
      errorBody = (
        <div className="message__content">
          <FormattedHTMLMessage id={`aio.errorCode.${authentication.exception}`} />
        </div>
      );
    }

    if (authentication.errorMessage) {
      errorBody = (
        <div className="message__content">
          {authentication.errorMessageValues
            ? (
              <FormattedHTMLMessage
                id={authentication.errorMessage}
                values={this.getValuesFromMessage(authentication.errorMessageValues)}
                defaultMessage={this.props.intl.formatMessage({ id: 'aio.errorCode.default' })}
              />
            )
            : <FormattedHTMLMessage id="aio.errorCode.default" />}
        </div>
      );
    } else if (authentication.errorCode) {
      errorBody = (
        <div className="message__content">
          <FormattedHTMLMessage id="aio.request_error.body" />
        </div>
      );
    }

    return (
      <div className="message message--error">
        <span className="message__icon" />
        {errorBody}
      </div>
    );
  }
}

AuthenticationErrorMessage.propTypes = propTypes;

export default connect(
  () => ({}),
  { logout }
)(injectIntl(AuthenticationErrorMessage));
